import { gql } from "@apollo/client";
import RaceFragment from "@urp/wagerpad/src/graphql/fragments/RaceFragment";

export const GET_RACES_SUBSCRIPTION = gql`
  subscription raceUpdateByTvgRaceIds(
    $wagerProfile: String!
    $product: String
    $brand: String
    $tvgRaceIds: [Long!]
  ) {
    raceUpdateByTvgRaceIds(
      profile: $wagerProfile
      tvgRaceIds: $tvgRaceIds
      brand: $brand
      product: $product
    ) {
      id
      tvgRaceId
      ...Race
      ...BettingInterests
    }
  }
  ${RaceFragment.entry}
`;
